// @flow
import { type Node } from 'react';
import { createPortal } from 'react-dom';

function usePortal(id: string, tagName: string = 'div'): HTMLElement {
  const element = document.getElementById(id) || document.createElement(tagName);
  return element;
}

type Props = {
  +id: string;
  +tagName?: string;
  +children: Node;
};
export function Portal({ id, tagName, children }: Props): Node {
  const element = usePortal(id, tagName);
  return createPortal(children, element);
}
